import apiService from "../../../../service/Api";

export interface SiteCompany {
  id: number;
  name: string;
}

export interface SiteApiItem {
  id: number;
  name: string;
  domain: string;
  category: string;
  category_display: string;
  status: string;
  status_display: string;
  logo: string | null;
  description: string | null;
  creator?: string;
  publisher?: string;
  default_locale?: string;
  is_active: boolean;
  company: SiteCompany;
  created_at: string;
  updated_at: string;
  created_by: number;
  created_by_name: string | null;
  last_updated_by: number | null;
  last_updated_by_name: string | null;
}

export interface SiteListApiItem {
  id: number;
  name: string;
  domain: string;
  category: string;
  category_display: string;
  status: string;
  status_display: string;
  logo: string | null;
  updated_at: string;
  last_updated_by_name: string | null;
}

export interface SitesApiResponse {
  results: SiteListApiItem[];
  count: number;
  next: string | null;
  previous: string | null;
}

export interface CreateSiteData {
  name: string;
  domain: string;
  category: string;
  status: string;
  description?: string | null;
  logo?: File | null;
  is_active?: boolean;
}

export interface UpdateSiteData {
  name?: string;
  domain?: string;
  category?: string;
  status?: string;
  description?: string | null;
  logo?: File | null;
  is_active?: boolean;
}

export const fetchSites = () => {
  return apiService.get<SitesApiResponse>("/api/configurations/sites/");
};

export const fetchSite = (id: number) => {
  return apiService.get<SiteApiItem>(`/api/configurations/sites/${id}/`);
};

export const createSite = (data: FormData) => {
  return apiService.post<SiteApiItem>("/api/configurations/sites/", data, false);
};

export const updateSite = (id: number, data: FormData) => {
  return apiService.patch<SiteApiItem>(
    `/api/configurations/sites/${id}/`,
    data,
    false
  );
};

export const deleteSite = (id: number) => {
  return apiService.delete(`/api/configurations/sites/${id}/`);
};
